module.exports = __webpack_public_path__ + "static/media/vie_douce2.842e1364.mp3";